export function useVisibilityGtm(
  elementRef: Ref<HTMLElement | null>,
  label: string,
  options: IntersectionObserverInit = { threshold: 1.0 },
) {
  const $gtm = useGtm()
  let observer: IntersectionObserver | null = null

  onMounted(() => {
    if (!elementRef.value) return

    observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return

      $gtm?.trackEvent({
        event: 'trackEvent',
        category: 'visibility',
        action: 'block',
        label,
      })

      observer?.unobserve(entry.target)
    }, options)

    observer.observe(elementRef.value)
  })

  onBeforeUnmount(() => {
    if (observer && elementRef.value) {
      observer.unobserve(elementRef.value)
    }
  })
}
